<template>
	<o-section
		class="unlock-module-aside"
		:title="setup.unlockModuleTitle">
		<div class="unlock-module-aside__section">
			<unlock-module-order-list
				v-if="setup.showSelect && type === PLUGIN_TYPE.Order"/>
		</div>
	</o-section>
</template>

<script setup lang="ts">
import UnlockModuleAsideSetupService from '@/setup/unlock-module/UnlockModuleAsideSetupService';
import UnlockModuleOrderList from '@/components/unlock-module/order/UnlockModuleOrderList.vue';
import { PLUGIN_TYPE } from '@/typings/enums/PLUGIN_TYPE';
const props = defineProps(UnlockModuleAsideSetupService.props);
const setup = new UnlockModuleAsideSetupService(props);
</script>


<style scoped lang="less">
.unlock-module-aside {

	/* &__separation {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1.3rem 0;
		font-size: 1.3rem;
		font-weight: 700;
		color: var(--grey-darker);
	} */

	&__section {
		margin: 0 -3.75rem;
		padding: 2.75rem;
		background: var(--grey-lighter);
		min-height: calc(100vh - 7.6rem);
	}
}
</style>
